import React, { useState } from "react";
import { usePagination } from "./usePagination";

import "./style.scss";
import { Link } from "gatsby";

const data = [1, 2, 3, 4, 5, 6, 7, 8];

const Paging = ({ totalPages, currentPage }) => {
  const {
    setNextPage,
    setPreviousPage,
    nextEnabled,
    previousEnabled,
    startIndex,
    endIndex,
  } = usePagination({ totalItems: 100, initialPage: 0, initialPageSize: 1 });

  const setPage = (pageNumber) => {
    const pageSlug = pageNumber === 1 ? "" : `/${pageNumber}`;

    if (typeof window !== "undefined") {
      const relativePath = window.location.pathname + window.location.search;

      if (pageNumber === 1) {
        return relativePath.replace(/\/[0-9]$/, "");
      } else if (relativePath.match(/\/[0-9]$/)) {
        return relativePath.replace(/\/[0-9]$/, pageSlug);
      } else {
        return `${relativePath}${pageSlug}`;
      }
    }
  };

  return (
    <div className="paging">
      <Link
        to={setPage(currentPage - 1 || 1)}
        title="Previous"
        className={`${currentPage === 1 && "disabled"} paging__prev`}
      >
        <i className="i-arrow-left"></i>
      </Link>
      <nav className="d-flex" aria-label="pagination">
        <ul className="pagination">
          {new Array(totalPages).fill(0).map((p, idx) => (
            <li
              className={`page-item${currentPage === idx + 1 ? " active" : ""}`}
            >
              <Link to={setPage(idx + 1)} title="" className={`page-link`}>
                {idx + 1}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <Link
        to={setPage(
          currentPage + 1 >= totalPages ? totalPages : currentPage + 1
        )}
        title="Next"
        className={`${currentPage === totalPages && "disabled"} paging__next`}
      >
        <i className="i-arrow-right"></i>
      </Link>
    </div>
  );
};

export default Paging;
